import React from "react";
import BaseComponent from "./baseComponent";
import LoginComponent from "./loginComponent";
import { history } from "../../managers/history";
import AuthService from "../../services/auth0";
import { sessionManager } from "../../managers/sessionManager";
import {
  actionTypeConstant,
  cookiesConstants,
  genericConstants,
  userRoles,
} from "../../constants/index";
import Utils, { dispatchAction } from "../../utility";
import { connect } from "react-redux";
import { UserService } from "../../services";
import { eventConstants } from "../../constants";

class Login extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: sessionManager.getDataFromCookies(cookiesConstants.EMAIL_ID)
        ? sessionManager.getDataFromCookies(cookiesConstants.EMAIL_ID)
        : "",
      emailError: "",
      password: sessionManager.getDataFromCookies(cookiesConstants.PASSWORD)
        ? sessionManager.getDataFromCookies(cookiesConstants.PASSWORD)
        : "",
      passwordError: "",
      wrongPasswordError: "",
      isPasswordVisible: false,
      isChecked: sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME)
        ? Boolean(
            sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME)
          )
        : false,
    };
    this.handleCheck = this.handleCheck.bind(this);
  }

  componentDidMount() {
    console.log(this.state.isChecked);

    console.log(
      sessionManager.getDataFromCookies(cookiesConstants.EMAIL_ID),
      sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME),
      "cokkiess"
    );
    if (
      sessionManager.getDataFromCookies(cookiesConstants.USER_ID) &&
      sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME)
    ) {
      console.log("in login");
      this.props.dispatchAction(
        actionTypeConstant.LOGIN_SUCCESS,
        sessionManager.getDataFromCookies(cookiesConstants.USER)
      );
      this.props.history.push("home/dashboard");
    }
  }
  onChangeEvent = (event) => {
    this.setState({ [event.target.id]: event.target.value });
  };
  onChangeChecked = (event) => {
    let { name, value } = event.target;
    this.setState({ isChecked: event.target.checked });
    console.log(event.target.checked, "event", this.state.isChecked);
    // this.setState({isChecked:!this.state.isChecked})
  };

  handleCheck(event) {
    console.log(this.state.isChecked, "isChecked");
    console.log(event);
    // this.setState({
    //     isChecked:!this.state.isChecked
    // })
  }

  routeChange = () => {
    history.push("reset");
  };

  togglePassword = (event) => {
    this.setState({ isPasswordVisible: !this.state.isPasswordVisible });
  };

  validateLoginForm = () => {
    this.setState({
      emailError: Utils.validateEmail(this.state.email)
        ? ""
        : "Invalid email address",
      passwordError: Utils.isPasswordValid(this.state.password)
        ? ""
        : "Password should contain 1 special character",
    });
    return (
      Utils.validateEmail(this.state.email) &&
      Utils.isPasswordValid(this.state.password)
    );
  };

  onLoginClicked = async (event) => {
    event.preventDefault();
    if (!this.state.email || !this.state.password) {
      Utils.apiFailureToast(genericConstants.INCORRECT_USERNAME_PASS);
      return;
    }
    if (!this.validateLoginForm()) {
      this.setState({ passwordError: "Invalid Credentials, failed to Login" });
      // Utils.apiFailureToast(
      //   <div style={{ whiteSpace: "nowrap", width: "260px" }}>
      //     {genericConstants.INVALID_PASSWORD_OR_EMAIL}
      //   </div>
      // );
      return;
    }
    // if (this.validateLoginForm())
    //     Utils.basicAlert("Login Successfully")
    this.props.dispatchAction(eventConstants.SHOW_LOADER);
    this.authObject = new AuthService();
    let [error, res] = await Utils.parseResponse(
      this.authObject.signin(this.state.email, this.state.password)
    );
    this.props.dispatchAction(eventConstants.HIDE_LOADER);
    if (!res || error) {
      let text = JSON.parse(error?.original?.response?.text);

      // Utils.apiFailureToast(
      //   text?.error_description || genericConstants.INCORRECT_USERNAME_PASS
      // ); this.setState({
        this.setState({ passwordError: "Wrong Email or Password" });
      return;
    } else {
      localStorage.setItem("userDetails", JSON.stringify(res));
      if (res.accessToken) {
        this.setAuthToCookies(res);
        // Utils.apiSuccessToast(genericConstants.LOGIN_SUCCESSFULL);
        sessionManager.setDataInCookies(true, cookiesConstants.IS_LOGIN);
        sessionManager.setDataInCookies(res, cookiesConstants.USER);
        if (this.state.isChecked) {
          sessionManager.setDataInCookies(
            this.state.email,
            cookiesConstants.EMAIL_ID
          );
          sessionManager.setDataInCookies(
            this.state.password,
            cookiesConstants.PASSWORD
          );
          sessionManager.setDataInCookies(
            this.state.isChecked,
            cookiesConstants.REMEMBER_ME
          );
        } else
          sessionManager.setDataInCookies(
            this.state.isChecked,
            cookiesConstants.REMEMBER_ME
          );

        this.props.dispatchAction(
          actionTypeConstant.LOGIN_SUCCESS,
          res.userDetails
        );
        history.push("/home/dashboard");
      }
    }
  };
  setAuthToCookies = ({ accessToken, userDetails }) => {
    sessionManager.setDataInCookies(accessToken, "accessToken");
    sessionManager.setDataInCookies(userDetails, "userDetails");
  };

  render() {
    return (
      <LoginComponent
        state={this.state}
        onChangeEvent={this.onChangeEvent}
        togglePassword={this.togglePassword}
        onLoginClicked={this.onLoginClicked}
        routeChange={this.routeChange}
        onChangeChecked={this.onChangeChecked}
      />
    );
  }
}
const mapStateToProps = (state) => {
  return { user: state.user };
};
export default connect(mapStateToProps, { dispatchAction })(Login);
